"use strict";
Object.defineProperty(exports, "__esModule", { value: true });



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-http-service/Contracts/AccessTokenProvider.ts